import { render } from "./TagSubTask.vue?vue&type=template&id=1883a5dc"
import script from "./TagSubTask.vue?vue&type=script&lang=js"
export * from "./TagSubTask.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__